import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/theme.css'
import '@/styles/global.scss'

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.config.errorHandler = function (err, vm, info) {
  console.error('[Vue Error]:', err, info)
  Message.error(err.message || '页面发生错误')
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
